module.exports = __webpack_public_path__ + "img/autosense-order.41f76d59.png";